// COMPONENT
import Day from "./Day";
import "../stylesheets/schedule.scss";
import { useState, useEffect } from "react";

const days = [
	"Lundi",
	"Mardi",
	"Mercredi",
	"Jeudi",
	"Vendredi",
	"Samedi",
	"Dimanche",
];

function Schedule() {
	const [selectedDay, setSelectedDay] = useState(days[0]);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 971);

	// Detect window resize to toggle mode
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 971);
		};
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	if (isMobile) {
		// Mobile layout: abbreviated days row + selected day
		return (
			<div className="schedule mobile">
				<div className="days-row">
					{days.map((day) => (
						<button
							key={day}
							className={`day-button primary-text ${
								day === selectedDay ? "active" : ""
							}`}
							onClick={() => setSelectedDay(day)}
						>
							{day.substring(0, 3) + "."}
						</button>
					))}
				</div>
				<div className="day-details">
					<Day name={selectedDay} />
				</div>
			</div>
		);
	}

	// Desktop layout: all days displayed
	return (
		<div className="schedule desktop">
			{days.map((day) => (
				<Day name={day} key={day} />
			))}
		</div>
	);
}

export default Schedule;
